import * as types from '../constants/ActionTypes'
import moment from 'moment'
import _ from "lodash";

const initalState = {
  transition: false,
  aaaa: false,
  form: {
      estimateCode: "",
      estimateAmmount: "",
  },
  selectData: {},
  kenmeiNames: {},
  costOpens: []
}

const toCostMonth = (cost) => {

    return cost.year + '/' + ('000' + cost.month).slice(-2);

    // let result = ''
    // if (cost.importDate) {
    //     const importDateArray = cost.importDate.split("_")
    //     result = moment(importDateArray[importDateArray.length - 1]).format("YYYY/MM")
    // } else {
    //     result = moment(cost.createdAt).format("YYYY/MM")
    // }

    // return result;
}

const toCostHistorys2 = (costs) => {

    const costMonths = costs
        .map(x => {
            return Object.assign({}, x, {month : toCostMonth(x)})
        }).sort((a, b) => {
            return (a.month < b.month) ? -1 : 1;
        })

    return costMonths;
}

const toCostHistorys = (costs, isRoumu) => {

    if (!costs) {
        return costs
    }

    const newCosts = costs.map(x => {
        return {
            budget:  x.budget,
            comment: x.comment,
            costId: x.costId,
            costKind:   x.costKind,
            costName:  x.costName,
            year:  x.year,
            month:  x.month,
            createdAt:    x.createdAt,
            id:  x.id,
            importDate:     x.importDate,
            result:  x.result,
            roumuDiff:    x.roumuDiff,
            transactionId:  x.transactionId,
            updatedAt:   x.updatedAt,
            yosanId:   x.yosanId,
        }
    })

    const costMonths = newCosts && newCosts
        .map(x => toCostMonth(x)).sort().filter(function (x, i, self) { return self.indexOf(x) === i; });

    const costHistorys = []

    costMonths && costMonths.forEach(month => {
        const matchData =
            newCosts.filter(x => {
                if (isRoumu && (!x.result || x.result == 0)) {
                    return false
                }
                return toCostMonth(x) == month
            })

        if (_.isEmpty(matchData)) {
            return
        }

        costHistorys.push({
            month: month,
            data: matchData
        })
    })

    return costHistorys;
}

const master = (state = initalState, action) => {

  switch (action.type) {

    case types.REDUCER_YOSAN_INIT: {

        const materialCostHistorys = toCostHistorys(action.payload.form.materialCosts)
        const roumuCostHistorys = toCostHistorys(action.payload.form.roumuCosts, true)
        const xronosRoumuCostHistorys = toCostHistorys(action.payload.form.xronosRoumuCosts, true)
        const outsourcingCostHistorys = toCostHistorys(action.payload.form.outsourcingCosts)
        const expenseCostHistorys = toCostHistorys(action.payload.form.expenseCosts)

        const sumTmp = {}
        action.payload.form.roumuCosts && action.payload.form.roumuCosts.forEach(x => {
            const sum = sumTmp[x.id]
            if (!sum) {
                sumTmp[x.id] = x
                return
            }
            sum.result += x.result
            sum.roumuDiff += x.roumuDiff
            sumTmp[x.id] = sum
        })
        const roumuCosts = []
        for(let k of Object.keys(sumTmp)) {
            roumuCosts.push(sumTmp[k])
        }

        const xronosSumTmp = {}
        action.payload.form.xronosRoumuCosts && action.payload.form.xronosRoumuCosts.forEach(x => {
            const sum = xronosSumTmp[x.id]
            if (!sum) {
                xronosSumTmp[x.id] = x
                return
            }
            sum.result += x.result
            sum.roumuDiff += x.roumuDiff
            xronosSumTmp[x.id] = sum
        })
        const xronosRoumuCosts = []
        for(let k of Object.keys(sumTmp)) {
            xronosRoumuCosts.push(xronosSumTmp[k])
        }

        const newForm = Object.assign({}, action.payload.form, {
            materialCostHistorys,
            roumuCostHistorys,
            xronosRoumuCostHistorys,
            outsourcingCostHistorys,
            expenseCostHistorys,
            materialCosts: null,
            outsourcingCosts: null,
            expenseCosts: null,
            roumuCosts: roumuCosts,
            xronosRoumuCosts: xronosRoumuCosts
        })

        const newPayload = Object.assign({}, action.payload, {form: newForm})

        return Object.assign({}, state, newPayload)

    } case types.REDUCER_YOSAN_HISTORY_INIT:
          const materialCostHistorys = toCostHistorys(action.payload.form.materialCosts)
          const roumuCostHistorys = toCostHistorys(action.payload.form.roumuCosts)
          const xronosRoumuCostHistorys = toCostHistorys(action.payload.form.xronosRoumuCosts)
          const outsourcingCostHistorys = toCostHistorys(action.payload.form.outsourcingCosts)
          const expenseCostHistorys = toCostHistorys(action.payload.form.expenseCosts)

          const newForm = Object.assign({}, action.payload.form, {
              materialCostHistorys,
              roumuCostHistorys,
              xronosRoumuCostHistorys,
              outsourcingCostHistorys,
              expenseCostHistorys
          })

          const newPayload = Object.assign({}, action.payload, {form: newForm})

          return Object.assign({}, state, newPayload)

    case types.USER_YOSAN_HISTORY_COST_OPEN:
        const kind = action.payload.kind
        const month = action.payload.month

        let costOpens = state.costOpens

        let newCostOpens = []
        let isUpdate = false
        costOpens.forEach(x => {
            let newOpen;
            if (x.kind == kind && x.month == month) {
                if (x.open) {
                    newOpen = false
                } else {
                    newOpen = true
                }
                isUpdate = true
            } else {
                newOpen = x.open
            }
            newCostOpens.push({
                kind: x.kind,
                month: x.month,
                open: newOpen
            })
        })

        if (!isUpdate) {
            newCostOpens.push({
                kind: kind,
                month: month,
                open: true
            })
        }

        return Object.assign({}, state, {costOpens: newCostOpens})

    case types.REDUCER_YOSAN_SET_TRANSITION:
    case types.REDUCER_YOSAN_SET_KENMEI_NAMES:
    case types.REDUCER_YOSAN_TEST:
      return Object.assign({}, state, action.payload)
    case types.REDUCER_YOSAN_STATE_CLEAR:
      return Object.assign({}, state, initalState)
    default:
      return state
  }
}

export default master


// WEBPACK FOOTER //
// ./src/reducers/yosan.js